import React, { Component } from 'react';
import $ from 'jquery';
import Script from 'react-load-script';
import { BrowserRouter as Router, Switch, Route, Link, browserHistory } from 'react-router-dom';
import DocImg1 from '../img/rightforwardfilmposter.jpg';
import DocImg2 from '../img/beyondthegulffilmposter.jpg';
import DocImg3 from '../img/Hanuman-Da-Damdaar.jpg';
import Shortfilm1 from '../img/bittersweetsfilmposter.jpg';
import Helmet from 'react-helmet';

class UnderProd extends Component {

	render() {
    return (
        <div>
        <Helmet
                title="Current Projects | RAT Films | Documentaries | Features"
                meta={[
                  { name: 'description', content: "Explore our projects which are under production. Know details of latest projects which are ongoing at Rat Films." },
                  

                  ]}
              />
        <section className="page-section under-prod ">
          
          <div className="container ">
            <h3 className="heading main">UNDER PRODUCTION</h3>
            
            <div className="row">
              <p className="subheading main">FEATURE FILMS</p>
              <div className="col-sm-6">
                <h2 className="subheading ft-green">HANUMAN DA DAMDAAR</h2>
                <p>Part of the first successful animation franchise in India, this is a fictional tale of one of India’s most noble and loved mythological characters, Hanuman.</p>
                <p>Adventure, fun, songs and a cast of some of ‘Bollywood’s’ most unique, iconic voices.</p>
                <p>Set to release in summer 2016.</p>
              </div>
              <div className="col-sm-6">
                <h2 className="subheading ft-green">FROM A TO Z</h2>
                <p>A love story about a gregarious boy from Bhendi Bazaar, Mumbai’s infamous inner city ghetto… and a bohemian author who is a cosmopolitan ‘global citizen’.</p>
                <p>A hilarious journey between two people from alien worlds and mind sets, as they go on a road trip around South India; a place alien to both of them.</p>
              </div>
            </div>

            <div className="row">
              <p className="subheading main">DOCUMENTARIES</p>
              <div className="col-sm-6">
                
                <h2 className="subheading ft-green">RIGHT FORWARD</h2>
                <div className="img-div"  style={{backgroundImage: `url(${DocImg1})`}}></div>
                <p>We follow the journey of a team of 12 girls from various slums in Mumbai.. as they face all kinds of odds to play football.. While the peg of the film is a journey from the Indian slums to San Francisco, America, the exploration of the film is the on-going change in them as individuals, leaders and eventually change makers in their communities. To be a part of their struggles and learning’s, the film has captured them run, fall, and get up again over the last 4 years.</p>
              </div>
              <div className="col-sm-6">
                
                <h2 className="subheading ft-green">BEYOND THE GULF</h2>
                <div className="img-div" style={{backgroundImage: `url(${DocImg2})`}}></div>
                <p>A 23year old boy goes for a religious pilgrimage ‘Umrah’ from Mumbai to various places in the Middle East. On his journey through Iran, Iraq, Syria, Jordan, Israel and Egypt, he meets the youth and senses a huge change is coming.. and it did.. in the ‘Arab Spring’. It’s a simple question of what does the youth want? It’s about their dreams and aspirations. It’s about the commonality between the youth beyond the gulf and in the gulf.</p>
              </div>
            </div>

            <div className="row">
              <p className="subheading main">SHORT FILMS</p>
              <div className="col-sm-6">
                
                <h2 className="subheading ft-green">BITTER SWEETS</h2>
                <div className="img-div" style={{backgroundImage: `url(${Shortfilm1})`}}></div>
                <p>Starring: Shraddha Das, Pragya Yadav, Pankaj Tripathi, Taher Shabbir, Vivek Vaswani & Sudhir Mishra.</p>
                <p>The first and only film to be entirely filmed on location in Bhendi Bazaar; Mumbai’s infamous inner city ghetto.</p>
              </div>
              <div className="col-sm-6">
                <h2 className="subheading ft-green"></h2>
                <div className="img-div no-image"></div>
                <p>It’s a love story between Zubair and Shifa, Zubair who works in a sweet shop in the ‘Mohallah’ (ghetto) and Shifa who has grown up in the ‘Mohallah’ (ghetto). It revolves around their brewing romance and people of the area. This 27min film is gripping and guarantees to surprise you with what its really about!</p>
              </div>
            </div>
          </div>
        </section>
		
        </div>

		
    );
  }
}

export default UnderProd;


// WEBPACK FOOTER //
// ./src/components/under_prod.js